import { IOption } from 'src/app/components/shared/form/components/form-select/form-select.model';
import { ColumnConfig } from 'src/app/components/shared/table/components/table/types';

export const CONST = {
  HEADER: $localize`Outbound Scan GLE`,
  SELECT_DATE: $localize`Select Date`,
  SORT_DATE: $localize`Sort Date`,
  SELECT: $localize`Select`,
  SORT: $localize`Sort`,
  NEXT: $localize`Next`,
  BACK: $localize`Back`,
  LOAD_NAME: $localize`Load Name`,
  SELECT_LOAD: $localize`Select Load`,
  MOVEMENT: $localize`Movement`,
  SUBMIT: $localize`Submit`,
  SEAL_CONTROL: $localize`Seal Control`,
  SEAL_CONTROL_PLACEHOLDER: $localize`Enter Seal Control`,
  DRY_ICE: $localize`Dry Ice`,
  HAZMAT: $localize`Hazmat`,
  EQUIPMENT_NUMBER: $localize`Equipment Number`,
  NUMBER_PLACEHOLDER: $localize`Enter Equipment Number`,
  SAVE: $localize`Save`,
  SELECTED_LOAD: $localize`Selected Load`,
  SELECTED_MOVEMENT: $localize`Selected Movement`,
  ACTION: $localize`Action`,
  TRACKING_NUMBER: $localize`Tracking Number`,
  TRACKING_NUMBER_PLACEHOLDER: $localize`Enter Tracking Number`,
  INVALID_TRACKING_NUMBER: $localize`Invalid Tracking Number Format`,
  FILE_UPLOAD: $localize`File Upload`,
  STATUS: $localize`Status`,
  REASON: $localize`Reason`,
  FLEX: $localize`Flex`,
  ULD_COUNT: $localize`ULD Count`,
  LOOSE_COUNT: $localize`Loose Count`,
  WARNING: {
    CONFIRM_BUTTON: $localize`Confirm`,
    REJECT_BUTTON: $localize`Cancel`,
    HEADER: $localize`Load anyway?`,
    OK_BUTTON: $localize`OK`,
    ALERT_HEADER: $localize`ALERT`,
    BODY_LINE_ONE: $localize`Do Not Load`,
    BODY_LINE_TWO: $localize`Hold. Bring to Supervisor`,
  },
  DONE: $localize`Done`,
  AMOUNT: $localize`Amount`,
  UNIT_OF_MEASURE: $localize`Unit of Measure`,
  LOAD_CHART: $localize`Load Chart`,
};

export enum FORM_Ids {
  SORT_DATE = 'sortDate',
  SORT = 'sort',
  MOVEMENT = 'movement',
  LOAD_NAME = 'loadName',
  LOAD_CHART = 'loadChart',
  EQUIPMENT_NUMBER = 'equipmentNumber',
  SEAL_CONTROL = 'sealControl',
  ACTION = 'action',
  TRACKING_NUMBERS = 'trackingNumbers',
  TYPE = 'type',
  DRY_ICE_AMOUNT_ONE = 'dryIceAmountOne',
  DRY_ICE_AMOUNT_TWO = 'dryIceAmountTwo',
  UNIT_OF_MEASURE = 'unitOfMeasure',
  HAZMAT = 'hazmat',
  DRY_ICE = 'dryIce',
}

export const ACTION_LIST: IOption[] = [
  {
    label: $localize`Add to ULD`,
    value: 'ADD',
  },
  {
    label: $localize`Remove to ULD`,
    value: 'REMOVE',
  },
];

export enum ColumnIds {
  TRACKING_NUMBER = 'trackingNumbers',
  STATUS = 'status',
  REASON = 'reason',
  FLEX = 'flex',
}

export const ColumnText = {
  TRACKING_NUMBER: $localize`Tracking Number`,
  STATUS: $localize`Status`,
  REASON: $localize`Reason`,
  FLEX: $localize`Flex`,
};

export const COLUMN_CONFIG: ColumnConfig[] = [
  {
    key: ColumnIds.TRACKING_NUMBER,
    title: ColumnText.TRACKING_NUMBER,
    isUpperCase: true,
  },
  {
    key: ColumnIds.STATUS,
    title: ColumnText.STATUS,
    isUpperCase: true,
  },
  {
    key: ColumnIds.REASON,
    title: ColumnText.REASON,
    isUpperCase: true,
  },
  {
    key: ColumnIds.FLEX,
    title: ColumnText.FLEX,
    isUpperCase: true,
  },
];

export type TableData = {
  trackingNumbers: string;
  status: string;
  reason: string;
  flex: string;
};
